import { Component } from '@angular/core';
import { AutorizacionService } from './services/autorizacion.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
//Datos de la pagina
  
  loggedIn=false;
  LoggedUser:any = null;

constructor(private AutorizacionService:AutorizacionService){
    this.AutorizacionService.isLogged()
      .subscribe((result)=> {
        if(result && result.uid){
          this.loggedIn=true;
          setTimeout(()=>{
            this.LoggedUser = this.AutorizacionService.getUser().currentUser.email;
      
            if (this.LoggedUser==null){
              this.LoggedUser = this.AutorizacionService.getUser().currentUser.displayName;
            }
          },500)
          
        }else{
          this.loggedIn=false;
        }
      }, (error)=>{
        this.loggedIn=false;
      })

	}

  //Funciones utilizadas ->
  logout(){
    this.AutorizacionService.logout();
  }


}






// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/app.component.ts